// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"811fe0f0","645":"73066bd4","661":"faab5cd6","777":"3f9fe3ca"}[chunkId] + ".chunk.css";
};